import {
  CenterArrivalDepartureTransfer,
  CenterArrivalDepartureTransferInput
} from '../../../lib/types/models/center/center-arrival-departure-transfers'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function updateCenterArrivalDepartureTransfers(
  id: number,
  data: CenterArrivalDepartureTransferInput[]
) {
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterArrivalDepartureTransfers.url, { id }))
    .patch<CenterArrivalDepartureTransfer[], CenterArrivalDepartureTransferInput[]>(data)
}
